export const setHidden = hidden => {
  return {
    type: 'NAVBAR_SET_HIDDEN',
    payload: hidden
  }
}
